import { ChakraProvider, extendTheme } from '@chakra-ui/react'
import React from 'react'
import { createRoot } from 'react-dom/client'

import { QueryClientProvider } from '@tanstack/react-query'
import { ErrorBoundary } from 'react-error-boundary'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'

// CSS
import { queryClient } from '@/lib/react-query'
import store from '@/stores'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-toastify/dist/ReactToastify.css'
import CSSReset from './theme/CSSReset'

import './lib/i18n'

import ErrorPage from '@/components/Page/ErrorPage'

import App from './App'

import theme from './theme'
import { BrowserRouter } from 'react-router-dom'

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)

root.render(
  <React.StrictMode>
    <React.Suspense fallback={<div>Loading....</div>}>
      <ChakraProvider theme={theme}>
        <ErrorBoundary FallbackComponent={ErrorPage}>
          <HelmetProvider>
            <QueryClientProvider client={queryClient}>
              <Provider store={store}>
                <BrowserRouter>
                  <App />
                </BrowserRouter>

                <ToastContainer style={{ width: '700px' }} pauseOnFocusLoss={false} position="top-center" limit={2} />
              </Provider>
            </QueryClientProvider>
          </HelmetProvider>
        </ErrorBoundary>
      </ChakraProvider>
    </React.Suspense>
  </React.StrictMode>
)
